import React from 'react'
import User from '../User.js'
const storage = window.localStorage

function Register(props) {
  return (
    <div>
    <h3>Hi stranger. <br/>What's your name?</h3>
    <input name="Your name" id="nameBox"></input><br/>
    <button className="ArticleButtonBox" onClick={() => {
      const name = document.getElementById('nameBox').value
      if (name.length > 0 && name.length < 15) {
        const newUser = new User(name)
        const user = JSON.stringify(newUser)
        storage.setItem('user', user)
        props.loggedIn()
      }
    }}>Let's start</button>
    </div>
  )
}

export default Register
